module.exports = __webpack_public_path__ + "bf7b9facdc7fd306ca46d82a89ad5397.svg";